var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"warning-block bg-kip-yellow text-center py-3 mb-4 px-5 text-sm font-bold rounded-lg"},[_vm._v("\n  "+_vm._s(_vm.warn)+"\n  "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }